import { render, staticRenderFns } from "./ManagerBudgetsSection.vue?vue&type=template&id=1f05a74e&scoped=true&"
import script from "./ManagerBudgetsSection.vue?vue&type=script&setup=true&lang=js&"
export * from "./ManagerBudgetsSection.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ManagerBudgetsSection.vue?vue&type=style&index=0&id=1f05a74e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f05a74e",
  null
  
)

export default component.exports